/* Import Local Modules */
import DetailModel from "./DetailModel.js";
import Attributes from "../../attribute/Attributes.js";
/* Initialize Constants */
const VALUE_TYPE = 'image';
const TYPE = `attr.detail.${VALUE_TYPE}`;

/**
 * Gets name from data.
 */
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

/* Initialize Model Base */
const base = {
  ...DetailModel,
  getName
};
delete base.create;

/**
 * Creates an attribute detail model instance.
 */
function create(attrName, objectType) {
  const mdl = DetailModel.create(TYPE, {
    attrName,
    objectType
  });
  mdl.label.align = 'top';
  return mdl;
}

/* Export Modules */
export default {
  TYPE,
  create,
  ...base
};